<template>
  <div v-if="isLoading" class="tw:w-full">
    <div class="tw:w-full tw:h-[2px] tw:bg-transparent tw:relative tw:overflow-hidden">
      <div class="tw:absolute tw:bottom-0 tw:top-0 tw:w-1/6 tw:h-full tw:bg-blue-700 tw:animate-loading" />
    </div>
  </div>
</template>
<script setup>
import { useSlideLoader } from '@/components/base/loaders/useSlideLoader.js'

const { isLoading } = useSlideLoader()
</script>
